import { FEATURES } from './features';

import type { Feature } from './features';
import type { FeatureDetails } from './types';

export function getFeatureDetails(feature: Feature): FeatureDetails {
  return FEATURES[feature];
}
